<div>
<postd-header></postd-header>
<postd-left-nav *ngIf="!(hideSidebar | async)"></postd-left-nav>
<div class="panel-column grid-container margin-top">
  <div class="page-content">
    <router-outlet (activate)="activateChild($event)"></router-outlet>
  </div>
</div>
</div>
